import { render, staticRenderFns } from "./operateRemoveOn.vue?vue&type=template&id=ae70e3ba&"
import script from "./operateRemoveOn.vue?vue&type=script&lang=ts&"
export * from "./operateRemoveOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports